$(document).on('click', '.collection-filter__title', function() {
  $(this).parent(".collection-filter__inner").toggleClass('open-this');
});



// 切换变体
$(document).on('click', '.product-item-color-swatch-item', function() {
  var mid = $(this).data('mid');
  $(this).closest('.product-item-color-swatch').find('.product-item-color-swatch-item').removeClass('active');
  $(this).addClass('active');
  var $productCard = $(this).closest('.new-product-card');
  $productCard.find('.variant-price').removeClass('active');
  $productCard.find('.variant-price-' + mid).addClass('active');
  $productCard.find('.img-variant').removeClass('active');
  $productCard.find('.img-variant-' + mid).addClass('active');
});



// Toggle between grid and list view
$(document).on('click', '.product-grid-and-list .item', function() {
  var viewType = $(this).data('type');
  
  // Update active state on buttons
  $('.product-grid-and-list .item').removeClass('active');
  $(this).addClass('active');
  
  // Update collection layout class
  var $collectionContent = $('#CollectionAjaxContent');
  
  if (viewType === 'grid') {
    $collectionContent.removeClass('list-view').addClass('grid-view');
    $collectionContent.find('.new-product-card').each(function() {
      $(this).find('.product-item-color-swatch').appendTo($(this).find('.grid-color-view-box'));
    });
  } else if (viewType === 'list') {
    $collectionContent.removeClass('grid-view').addClass('list-view');
    $collectionContent.find('.new-product-card').each(function() {
      $(this).find('.product-item-color-swatch').appendTo($(this).find('.list-color-view-box')); 
    });
  }
});


// mb
$(document).ready(function(){
    if($(window).width() < 768){
   $(".collection-list-box .collection-dropdowns").appendTo($(".mb-sort-by-box"));
    }
    // else{
        
    //     $(".pc-collection-filter-box").appendTo($(".pc-collection-filter-box"));
    // }
})
 

$(document).on('click', '.mb-collection-filter-left-box', function(){
    $("body").addClass('open-filter-box');
})

$(document).on('click', '.mb-collection-filter-header .header-close-box', function(){
    $("body").removeClass('open-filter-box');
})



$(document).on('click', '.header-search-box .search-box__button', function() {
  var keyword = $(".header-search-box .search-box__input").val().trim();
  window.location.href = '/search?type=product&options%5Bunavailable_products%5D=last&options%5Bprefix%5D=last&q=' + encodeURIComponent(keyword);
});



$(document).ready(function() {
  var urlParams = new URLSearchParams(window.location.search);
  if (urlParams.has('search') && urlParams.has('q')) {
    var searchQuery = urlParams.get('q');
    $(".header-search-box .search-box__input").val(decodeURIComponent(searchQuery));
  }
});
